export function exportToCsv(rows: any[], fileName: string, headers : any[]): void {
  if (!rows || !rows.length) {
    return;
  }
  const separator = ',';
  const keys = Object.keys(rows[0]);
  const csvContent =
    headers.map(h => {
      return keys.map(k => {
        let cell = h[k] === null || h[k] === undefined ? '' : h[k];
        if (cell.search(/("|,|\n)/g) >= 0) {
          cell = `"${cell}"`;
        }
        return cell;
      }).join(separator);
    }).join('\n') + '\n' +

    keys.join(separator) +
    '\n' +
    rows.map(row => {
      return keys.map(k => {
        let cell = row[k] === null || row[k] === undefined ? '' : row[k];
        cell = cell instanceof Date
          ? cell.toLocaleString()
          : cell.toString().replace(/"/g, '""');
        if (cell.search(/("|,|\n)/g) >= 0) {
          cell = `"${cell}"`;
        }
        return cell;
      }).join(separator);
    }).join('\n');
  downloadCsv(csvContent, fileName + '.csv');
}

export function downloadCsv(csv, filename): void {
  if (window.navigator.msSaveOrOpenBlob) {
    const blob = new Blob([decodeURIComponent(encodeURI(csv))], {
      type: 'text/csv;charset=utf-8;'
    });
    navigator.msSaveBlob(blob, filename);
  } else {
    const element = document.createElement('a');
    const universalBOM = '\uFEFF';
    const csvData = 'data:application/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csv);
    element.setAttribute('href', csvData);
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }
}


export function downloadBlob(blob: Blob, fileName: string): void {
  const binaryData: BlobPart[] = [];
  binaryData.push(blob);
  if (window.navigator.msSaveBlob) {
    const blob = new Blob(binaryData, { type: 'blob' });
    navigator.msSaveBlob(blob, fileName);
  } else {
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
}